/**
 * White-Ink Options eligibility — a small lookup table that tells us
 * whether the "Keep white in design" / "Make white areas clear" picker
 * should appear for the currently-selected (subcategory, material).
 *
 * Eligible products (per user request 2026-04-27):
 *   Decals & Clings:   Clear Decals, Static Cling CLEAR (white variant excluded)
 *   Labels:            Clear BOPP (Rolls), Gold & Silver Foil (Rolls)
 *   Stickers:          Glitter, Holographic, Transparent
 *   Unique Custom:     Glow In The Dark, UV DTF Stickers
 *   Wearables:         DTF Heat Transfers
 *
 * The mapping uses the canonical `subcategory.id` values from
 * `data/mockData.js`. Static-clings is the only one gated additionally
 * on the material id (clear vs white).
 */

// Subcategory ids that ALWAYS show the picker.
const ALWAYS_ELIGIBLE_SUBCATS = new Set([
  // Decals & Clings
  'clear-decals',
  // Labels
  'clear-bopp-rolls',
  'gold-silver-foil',
  // Stickers
  'glitter-stickers',
  'holographic-stickers',
  'transparent-stickers',
  // Unique Custom Products
  'glow-in-dark',
  'uv-dtf-stickers',
  // Wearables
  'dtf-heat-transfers',
]);

// Subcategory + material conditional eligibility.
// Static-clings: only the CLEAR material qualifies — white static clings
// already have their substrate paint and don't need a white-ink toggle.
const isClearStaticCling = (subcategoryId, materialId) =>
  subcategoryId === 'static-clings' &&
  typeof materialId === 'string' &&
  materialId.startsWith('clear-');

export const isWhiteInkEligible = (subcategoryId, materialId) => {
  if (!subcategoryId) return false;
  if (ALWAYS_ELIGIBLE_SUBCATS.has(subcategoryId)) return true;
  return isClearStaticCling(subcategoryId, materialId);
};

/** Canonical option ids stored on the order item. */
export const WHITE_INK_OPTIONS = {
  KEEP: 'keep',
  CLEAR: 'clear',
};

/** Customer-facing label for the proof header / order summary. */
export const whiteInkOptionLabel = (option) => {
  if (option === WHITE_INK_OPTIONS.CLEAR) return 'Make white areas clear';
  return 'Keep white in design';
};
